import { ClipboardList, Lock, CheckCircle2 } from "lucide-react";
import { fmtClock } from "./kioskUtils";

export const ClosingButton = ({ closing, onStart }) => {
  if (!closing) return null;
  if (closing.done) return (
    <div className="mb-6 p-4 rounded-lg border border-green-500/50 bg-green-500/10 text-green-300 flex items-center gap-2" data-testid="kiosk-closing-done">
      <CheckCircle2 size={18} /> Closing done today by {closing.closed_by_name} at {fmtClock(closing.submitted_at)}
    </div>
  );
  const enabled = closing.window_open;
  return (
    <div className="mb-6">
      <button onClick={onStart} disabled={!enabled}
        className="w-full sm:w-auto px-6 py-4 rounded-lg text-lg font-bold flex items-center justify-center gap-3 bg-yellow-400 text-black hover:bg-yellow-300 disabled:bg-neutral-900 disabled:text-neutral-500 disabled:border disabled:border-neutral-800 transition-colors"
        data-testid="kiosk-closing-btn">
        {enabled ? <ClipboardList size={22} /> : <Lock size={20} />} Perform Closing Activities
      </button>
      <div className="text-xs text-neutral-500 mt-2" data-testid="kiosk-closing-hint">
        {closing.closes_at
          ? (enabled ? `Store closes at ${fmtClock(closing.closes_at)}` : `Available from ${fmtClock(closing.window_opens_at)} (30 min before closing)`)
          : "No closing time set for today"}
      </div>
    </div>
  );
};
